import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface InfoCardProps {
  title: string;
  children: ReactNode;
}

/**
 * Reusable card panel for sidebar sections (user info, groups, settings, etc.)
 */
export function InfoCard({ title, children }: InfoCardProps) {
  return (
    <Card>
      <CardContent>
        <Typography
          variant="overline"
          color="text.secondary"
          gutterBottom
          component="h2"
          sx={{ display: 'block' }}
        >
          {title}
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
}
